import React, { useRef, useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";

const DatesHeader = ({
  selectedDate,
  slideShowCount,
  dates,
  setSelectedDate,
  canSwitchDate,
  sliderRef = null,
  arrowShow = true,
}) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slideShowCount,
    slidesToScroll: 1,
    prevArrow: arrowShow ? left : false, // Use the custom Prev button
    nextArrow: arrowShow ? right : false,
  };
  return (
    <SliderWrapper className="">
      <Slider {...settings} ref={sliderRef} className="px-5">
        {dates?.map((itm, index) => (
          <div key={index} className="cursor-pointer py-3">
            {canSwitchDate ? (
              <button
                type="button"
                className="border-0 p-0 bg-transparent"
                onClick={() => setSelectedDate(itm?.date)}
              >
                <TopWeekWrp
                  className={`${
                    selectedDate === itm?.date && "active"
                  } cardCstm  text-center py-2 px-3 rounded relative text-gray-500`}
                >
                  <p className="m-0">{itm?.day}</p>
                  <p className="m-0 text-xs">{itm?.dateLabel}</p>
                </TopWeekWrp>
              </button>
            ) : (
              <TopWeekWrp
                className={`${
                  selectedDate === itm?.date && "active"
                } cardCstm  text-center py-2 px-3 rounded relative text-gray-500`}
              >
                <p className="m-0">{itm?.day}</p>
                <p className="m-0 text-xs">{itm?.dateLabel}</p>
              </TopWeekWrp>
            )}
          </div>
        ))}
      </Slider>
    </SliderWrapper>
  );
};
const SliderWrapper = styled.div`
  .slick-arrow {
    background: transparent !important;
    // filter: brightness(0.5);
    height: 24px;
    width: 24px;
  }
`;

const TopWeekWrp = styled.div`
  &:after {
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    bottom: 0;
    height: 10px;
    width: 10px;
    margin: 0 auto;
    background: #3e0799;
    transform: translateY(95%);
    clip-path: polygon(50% 100%, 0 0, 100% 0);
    opacity: 0;
  }
  &.active {
    background: #3e0799;
    color: #fff;
    &:after {
      opacity: 1;
    }
  }
`;

export default DatesHeader;

const right = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
      stroke="#3E0799"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M10.5 16.5L15 12L10.5 7.5"
      stroke="#3E0799"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const left = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2Z"
      stroke="#3E0799"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M13.5 7.5L9 12L13.5 16.5"
      stroke="#3E0799"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
